// Paths are ../app's own: printed QR bookmarks and shared links point at them.
// No /orientation route: it is a separate document with its own COOP/COEP
// headers and must be reached by a full page load.
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { MilestoneToast } from "@/chrome/milestone-toast";
import { Navbar } from "@/chrome/navbar";
import { DesignProvider } from "@/components/design-switcher";
import { AboutPage } from "@/routes/about";
import { AffiliatePage } from "@/routes/affiliate";
import { HomePage } from "@/routes/home";
import { LibraryPage } from "@/routes/library";
import { NotFoundPage } from "@/routes/not-found";
import { RequireReader, SELECT_READER_PATH } from "@/routes/require-reader";
import { SelectReaderPage } from "@/routes/select-reader";
import { SignInPage } from "@/routes/sign-in";
import {
  SIGN_OUT_CONFIRM_PATH,
  SIGN_OUT_PATH,
  SignOutPage,
} from "@/routes/sign-out";
import { SignedOutPage } from "@/routes/signed-out";
import { StatsPage } from "@/routes/stats";
import { WordListPage } from "@/routes/word-list";

const ReadingPage = lazy(() =>
  import("@/routes/reading/reading-page").then((m) => ({
    default: m.ReadingPage,
  })),
);

const GalleryPage = lazy(() =>
  import("@/routes/gallery").then((m) => ({ default: m.GalleryPage })),
);

export function App() {
  return (
    <DesignProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route element={<RequireReader />}>
          <Route path="/reader" element={<LibraryPage />} />
          <Route
            path="/reader/:readingId"
            element={
              <Suspense fallback={null}>
                <ReadingPage />
              </Suspense>
            }
          />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/word-list" element={<WordListPage />} />
        </Route>
        <Route path={SELECT_READER_PATH} element={<SelectReaderPage />} />
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path={SIGN_OUT_PATH} element={<SignOutPage />} />
        <Route path={SIGN_OUT_CONFIRM_PATH} element={<SignOutPage />} />
        <Route path="/signed-out" element={<SignedOutPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route
          path="/reader/:readingId/affiliate"
          element={<AffiliatePage />}
        />
        <Route
          path="/gallery"
          element={
            <Suspense fallback={null}>
              <GalleryPage />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <MilestoneToast />
    </DesignProvider>
  );
}
